import script from "./UpdateUser.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateUser.vue?vue&type=script&setup=true&lang=js"

import "./UpdateUser.vue?vue&type=style&index=0&id=5a645c40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a645c40"]])

export default __exports__